import { IAppState } from '../rootReducer';
import { IAuthenticationState } from './authenticationReducer';

export const isAuthenticatedSelector = (state: IAppState): boolean => {
  return !!state.authenticationState.token;
};
